//=================================================
//    summary: DCP BC Apps Window -- Hook
//
//    remarks: 000 Tim 2021/11/04 Create
//             000 Tim 2021/12/23 fix Bug BI的產品點下去會一直跳update counter錯誤
//================================================
import React, { useEffect } from 'react'
import cssBCAppsWindows from './BCAppsWindows.module.scss'
import {ClientGatewayInPackage, GlobalLibs, NetworkLibs} from 'bc-react-package'

// #region Member Variables
let mblnInitialized = false

let mobjCallParam = null
// #endregion Member Variables

// #region Enumeration
const OpenAppEnum = {
    "AI": 1,
    "Library": 2,
    "BI": 3,
    "MC": 4
}

const ItemTypeEnum = {
    "BINE": 1,
    // "DCP": 2,
    // "DCPAssessment": 3,
    "AI": 4,
    "MC": 5,
    // "MCWorkbook": 6,
    // "MCAssessment": 7,
    // "MCMobile": 8,
    "Library": 9
}
// #endregion Enumeration


const COMP_NAME = "BCAppsWindows"

function BCAppsWindows(props)
{
    console.log(COMP_NAME + ".Begin: ", props)

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + " Init variable")

        mblnInitialized = true

        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)    
    } // end of if (!mblnInitialized)
    // #endregion First Launch

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")
            
            mblnInitialized = false
        }
    }, [])


    // #region OnTapHandler
    /*===========================================
    summary: 點選 關閉
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function CloseOnTapHandler()
    {
        console.log(COMP_NAME + ".CloseOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }
        
        let objCallbackData = {
            "Action": "CloseShowBCAppsWindows"
        }
        props.CallbackRef(objCallbackData)
    } // end of CloseOnTapHandler

    /*===========================================
    summary: 點選 產品
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function ProductOnTapHandler(OpenApp, ItemType)
    {
        console.log(COMP_NAME + ".ProductOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }
        
        let intAction = OpenApp
        let strQueryString = GetQueryString()

        OpenProduct(intAction, strQueryString)

        mobjCallParam = {
            "AccountID": window.gSession.Acc.ID,
            "CouterType": 4,        // 1. Trial 頁面 產品 點擊 統計； 2: DCP Reminder； 3: Subscription； 4: BCApps
            "ItemType": ItemType    // 各按鈕編號 
        }
        UpdateProductCounter()
    } // end of ProductOnTapHandler
    // #endregion OnTapHandler

    // #region Other Functions
    /*===========================================
    summary: 開啟 該產品
    remarks: 000 Tim 2021/11/04 Create
             001 Tim 2023/06/19 CallApp前 清空 AppCallbackRef
             002 Tim 2023/08/18 改寫 ClientGatewayInPackage.CallApp(
                                參數 要改用 最新版本 QueryString, CallbackFuncRef
    ===========================================*/
    function OpenProduct (Action, QueryString)
    {
        const FUNC_NAME = OpenProduct.name
        console.log(COMP_NAME + "." + FUNC_NAME + ": ", Action, QueryString)

        let strUrl = ""
        switch (Action)
        {
            case OpenAppEnum.BI:
                strUrl = window.gConfig.BIUrl
                break
            case OpenAppEnum.AI:
                strUrl = window.gConfig.AIUrl
                break
            case OpenAppEnum.Library:
                strUrl = window.gConfig.LibraryUrl
                break
            case OpenAppEnum.MC:
                strUrl = window.gConfig.MCUrl
                break
            default:
                break
        } // end of switch (Action)

        if (!window.gSession.App.InApp)
        {
            console.log(COMP_NAME + "." + FUNC_NAME + " Web strUrl: ", strUrl)
            window.open(strUrl + "?" + QueryString)
        } // end of if (!window.gSession.App.InApp)
        else
        {
            // In App
            var strWebSiteUrl = strUrl + "?" + QueryString
            console.log(COMP_NAME + "." + FUNC_NAME + " CallApp strWebSiteUrl: ", strWebSiteUrl)

            let intAction = window.gConst.ACTION_OPEN_BROWSER
            let strQueryString = "Action=" + intAction
            strQueryString += "&Credential=" + window.gSession.Acc.Credential
            strQueryString += "&BackRoute="
            strQueryString += "&Url=" + encodeURIComponent(strWebSiteUrl)

            console.log(COMP_NAME + "." + FUNC_NAME + " strQueryString: ", strQueryString)

            // ClientGatewayInPackage.CallApp(strQueryString, window.CallAppAPI, window.gSession.App.InApp, window.gSession.App.iOSNewGateway)
            ClientGatewayInPackage.CallApp(strQueryString)
        } // end of else
    } // end of OpenProduct

    /*===========================================
    summary: 取得 開啟網址 QueryString
    remarks: 000 Tim 2020/11/04 Create
    ===========================================*/
    function GetQueryString ()
    {
        console.log(COMP_NAME + ".GetQueryString");

        // 暫時先用笨解法 轉換環境參數   Tim15.08.19
        let intEnv = GlobalLibs.GetIntEnv(window.gSession.App.Env)

        // 增加參數 AccountID   Tim16.05.19
        let strQueryString = "Credential=" + window.gSession.Acc.Credential
        strQueryString += "&BackRoute="
        strQueryString += "&LoginName=" + window.gSession.Acc.LoginName
        strQueryString += "&AccountID=" + window.gSession.Acc.ID
        strQueryString += "&lang=" + window.gSession.Acc.Preferences.Lang
        strQueryString += "&Env=" + intEnv

        console.log("GetQueryString strQueryString: ", strQueryString)

        return strQueryString
    }  // end of GetQueryString
    // #endregion Other Functions

    // #region Web Service After Process
    /*===========================================
    summary: 更新 按鈕 計次後 的 流程
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function UpdateProductCounterAfterProcess ()
    {   
        console.log(COMP_NAME + ".UpdateProductCounterAfterProcess")
        mobjCallParam = null
    } // end of UpdateProductCounterAfterProcess
    // #endregion Web Service After Process

    // #region Web Service
    /*===========================================
    summary: 更新 按鈕 計次
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function UpdateProductCounter ()
    {
        let objRetryFuncRef = UpdateProductCounter
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = UpdateProductCounterCallback
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY;

            // // Open Loading mask with message
            // OpenLoadingMask(window.gAppUI.MSG_LoadMask_UpdateProductCounter)

            let objCallData = {
                "Func": "UpdateProductCounter",
                "AccountID": mobjCallParam.AccountID,
                "CouterType": mobjCallParam.CouterType, // 1. Trial 頁面 產品 點擊 統計 2: DCP Reminder 3: Subscription
                "ItemType": mobjCallParam.ItemType      // 各按鈕編號 
            };

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of UpdateProductCounter

    /*===========================================
    summary: 更新 按鈕 計次 Callback
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function UpdateProductCounterCallback (Return, InstructionInfo)
    {
        // // Close Loading mask        
        // CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_UpdateProductCounter_No
        let strErrorTitle = window.gAppUI.ERR_UpdateProductCounter_Title
        let strErrMsg = window.gAppUI.ERR_UpdateProductCounter_Msg
        // end of customize

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            }

            console.log("UpdateProductCounterCallback: ErrNo: ", Return.ErrNo)
            console.log("UpdateProductCounterCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("UpdateProductCounterCallback Return.Data: ", Return.Data)

            UpdateProductCounterAfterProcess()
        }
    } // end of UpdateProductCounterCallback
    // #endregion Web Service

    // #region Render元件
    /*===========================================
    summary: Product MC 顯示Component  
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function ComponentProductMC()
    {   
        return(
            <div className={cssBCAppsWindows.divProductUnitMC}
                    onClick={() => ProductOnTapHandler(OpenAppEnum.MC, ItemTypeEnum.MC)}>
                <div className={cssBCAppsWindows.divProductImageMC}/>
                <div className={cssBCAppsWindows.divProductName}>
                    {window.gAppUI.LBL_MC}
                </div>
            </div>
        )
    } // end of ComponentProductMC

    /*===========================================
    summary: Product BI 顯示Component  
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function ComponentProductBI()
    {   
        return(
            <div className={cssBCAppsWindows.divProductUnitLeft}
                    onClick={() => ProductOnTapHandler(OpenAppEnum.BI, ItemTypeEnum.BINE)}>
                <div className={cssBCAppsWindows.divProductImageBI}/>
                <div className={cssBCAppsWindows.divProductName}>
                    {window.gAppUI.LBL_BI}
                </div>
            </div>
        )
    } // end of ComponentProductBI

    /*===========================================
    summary: Product Library 顯示Component  
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function ComponentProductLibrary()
    {   
        return(
            <div className={cssBCAppsWindows.divProductUnitRight}
                    onClick={() => ProductOnTapHandler(OpenAppEnum.Library, ItemTypeEnum.Library)}>
                <div className={cssBCAppsWindows.divProductImageLibrary}/>
                <div className={cssBCAppsWindows.divProductName}>
                    {window.gAppUI.LBL_Library}
                </div>
            </div>
        )
    } // end of ComponentProductLibrary

    /*===========================================
    summary: Product AI 顯示Component  
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function ComponentProductAI()
    {   
        return(
            <div className={cssBCAppsWindows.divProductUnitLeft} 
                    onClick={() => ProductOnTapHandler(OpenAppEnum.AI, ItemTypeEnum.AI)}>
                <div className={cssBCAppsWindows.divProductImageAI}/>
                <div className={cssBCAppsWindows.divProductName}>
                    {window.gAppUI.LBL_AI}
                </div>
            </div>
        )
    } // end of ComponentProductAI

    /*===========================================
    summary: Title 顯示Component  
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function ComponentTitle()
    {   
        return(
            <div className={cssBCAppsWindows.divTitle}>
                {window.gAppUI.LBL_BCApps}
            </div>
        )
    } // end of ComponentTitle

    /*===========================================
    summary: Close Button 顯示Component  
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function ComponentCloseButton()
    {   
        return(
            <div className={cssBCAppsWindows.btnClose} onClick={() => CloseOnTapHandler()}/>
        )
    } // end of ComponentCloseButton
    // #endregion Render元件

    // #region Render
    /*===========================================
    summary: Render Product Content 的顯示
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function RenderProductContentWrapper()
    {
        return (
            <div className={cssBCAppsWindows.divProductContent}>
                <div className={cssBCAppsWindows.divProductTopSubContent}>
                    <ComponentProductAI />
                    <ComponentProductLibrary />
                </div>

                <div className={cssBCAppsWindows.divProductBottomSubContent}>
                    <ComponentProductBI />
                    <ComponentProductMC />
                </div>
            </div>
        )
    } // end of RenderProductContentWrapper

    /*===========================================
    summary: Render Content 的顯示
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function RenderContentWrapper()
    {
        return (
            <div className={cssBCAppsWindows.divContent}>
                <ComponentCloseButton />

                <ComponentTitle />

                {RenderProductContentWrapper()}
            </div>
        )
    } // end of RenderContentWrapper

    /*===========================================
    summary: Render 主畫面 的顯示
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function RenderMainWrapper()
    {
        return (
            <div className={cssBCAppsWindows.divMask}>
                {RenderContentWrapper()}
            </div>
        )
    } // end of RenderMainWrapper

    // Similar to Render
    return (
        <>
            {RenderMainWrapper()}
        </>
    )
    // #endregion Render
}
export default BCAppsWindows